import React, {PureComponent} from "react"
import styled from "styled-components"
import {Reward} from "@irati/types"
import {RouterLink as RouterLinkBase} from "@irati/ui/src/Link"
import getId from "@irati/utils/id"
import BannerComponent from "./Banner"
import DetailsComponent from "./Details"
import {Wrapper} from "./styled"

const RouterLink = styled(RouterLinkBase)`
  :hover {
    text-decoration: none;
  }
`

export interface TileProps {
  id: string,
  reward: Reward,
  className?: string
}

class TileComponent extends PureComponent<TileProps> {
  render() {
    const {id, className, reward} = this.props

    return (
      <RouterLink id={getId("link", this.props)} to={`/reward/${reward.urlSlug}`} plain>
        <Wrapper id={id} className={className}>
          <BannerComponent id={getId("banner", this.props)} reward={reward} />
          <DetailsComponent id={getId("details", this.props)} reward={reward} />
        </Wrapper>
      </RouterLink>
    )
  }
}

export default TileComponent
